import _slicedToArray from "/home/travis/build/Adrian265431/viadeUO265431/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useReducer, useEffect, useDebugValue } from 'react';
import auth from 'solid-auth-client'; // Keep track of the WebID and the state setters tracking it

var webId = undefined;
var subscribers = new Set();

var getWebId = function getWebId(_, id) {
  return id;
};
/**
 * Returns the WebID (string) of the active user,
 * `null` if there is no user,
 * or `undefined` if the user state is pending.
 */


export default function useWebId() {
  var reducer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getWebId;

  var _useReducer = useReducer(reducer, webId, reducer),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      result = _useReducer2[0],
      updateWebId = _useReducer2[1];

  useDebugValue(webId);
  useEffect(function () {
    updateWebId(webId);
    subscribers.add(updateWebId);
    return function () {
      return subscribers.delete(updateWebId);
    };
  }, []);
  return result;
} // Inform subscribers when the WebID changes

auth.trackSession(function (session) {
  webId = session ? session.webId : null;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = subscribers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var subscriber = _step.value;
      subscriber(webId);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
});